/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup'

import {
  GET_CONTRACTS_BY_CURRENT_USER,
  GET_TRANSACTIONS_ACTION_BY_CONTRACT_ID,
  GET_LAST_PAYMENT_BY_CONTRACT_ID,
  GET_PAYMENT_AMOUNT_DETAIL_BY_CONTRACT_ID,
  GET_PAYMENT_ROUND_DETAIL_BY_CONTRACT_ID,
  GET_DASHBOARD_DETAIL_BY_CONTRACT_ID,
  CREATE_QR_PAYMENT
} from '@/queries/modules/accounting'

import {
    error,
    addItemSuccess,
} from '@/utils/notification'
import {IPaymentAmountDetailType} from "@/constants/interface";

export async function getContract(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const contract = context.state.contracts.find(contract => contract.id === payload.form.id)
      context.commit('setContract', contract)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', null)
  }
}

export async function getContractsByCurrentUser(context) { //payload
  // console.log('Get Contracts By User...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const response = await apolloClient
          .query({
              query: GET_CONTRACTS_BY_CURRENT_USER,
              fetchPolicy: 'network-only'
          })
      const {data} = await response
      const {getContractsByCurrentUser} = data
      context.commit('setContracts', getContractsByCurrentUser)
      context.commit('setContract', getContractsByCurrentUser[0])
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', null)
  }
}

export async function getTransactionsActionByContractId(context, payload) {
  // console.log('Get Contracts By User...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.form.contractId,
    filters: payload.form.filters
  }
  try {
      const response = await apolloClient
        .query({
            query: GET_TRANSACTIONS_ACTION_BY_CONTRACT_ID,
            variables,
            fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getTransactionsActionByContractId} = data
      context.commit('setTransactions', getTransactionsActionByContractId)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', null)
  }
}

export async function getLastPaymentByContractId(context, payload) {
  // console.log('Get Contracts By User...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.form.contractId
  }
  try {
      const response = await apolloClient
        .query({
            query: GET_LAST_PAYMENT_BY_CONTRACT_ID,
            variables,
            fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getLastPaymentByContractId} = data
      context.commit('setPayment', getLastPaymentByContractId)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', null)
  }
}

export async function getPaymentAmountDetailByContractId(context, payload) {
  // console.log('Get Contracts By User...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.form.contractId,
    type: payload.form.type,
    amount: payload.form.amount
  }
  try {
      const response = await apolloClient
        .query({
            query: GET_PAYMENT_AMOUNT_DETAIL_BY_CONTRACT_ID,
            variables,
            fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getPaymentAmountDetailByContractId} = data

      if(payload.form.type === IPaymentAmountDetailType.normal){
        context.commit('setPaymentAmountDetail', getPaymentAmountDetailByContractId)
      }else if(payload.form.type === IPaymentAmountDetailType.outstanding){
        context.commit('setPaymentAmountDetailOutstanding', getPaymentAmountDetailByContractId)
      } else if(payload.form.type === IPaymentAmountDetailType.close){
        context.commit('setPaymentAmountDetailClose', getPaymentAmountDetailByContractId);
      }

      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', null)
  }
}

export async function getPaymentRoundDetailByContractId(context, payload) {
  // console.log('Get Contracts By User...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.form.contractId
  }
  // console.log(variables)

  try {
      const response = await apolloClient
        .query({
            query: GET_PAYMENT_ROUND_DETAIL_BY_CONTRACT_ID,
            variables,
            fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getPaymentRoundDetailByContractId} = data

      context.commit('setPaymentRoundDetail', getPaymentRoundDetailByContractId)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', null)
  }
}

export async function getDashboardDetailByContractId(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.form.contractId
  }

  try {
    const response = await apolloClient
      .query({
        query: GET_DASHBOARD_DETAIL_BY_CONTRACT_ID,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {dashboardDetail} = data

    context.commit('setDashboardDetail', dashboardDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', null)
  }
}

export async function createQrPayment(context, payload) {
  // console.log('Add QrPayment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  // const vm = payload.vm
  const variables = {
      contractId: payload.contractId,
      payload: payload.form
  }
  try {
      const response = await apolloClient
          .mutate({
              mutation: CREATE_QR_PAYMENT,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      const {createQrPayment} = data
      context.commit('setQrPayment', createQrPayment)
      context.commit('setSuccess', null);
      return true
  } catch (e) {
      context.commit('setError', error(null, null))
      return e
  }
}
